export const fieldsTypes = [
  'Múltipla escolha',
  'Texto',
  'Única escolha',
  'Número inteiro',
  'Número decimal',
  'Data',
]